"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllMetadata = exports.Metadatum = exports.decodeMetadata = void 0;

var metadata_1 = require("./http/metadata");
/* {"domain":"comsel.device","key":"port.prefix","value":"a732243994670404","setAt":"2020-04-22T09:53:45Z"} */


exports.decodeMetadata = function (i) {
  if (i == null) {
    console.log("decodeMetadata called with null value");
    return new Metadatum("", "");
  }

  return new Metadatum(i.domain, i.key, i.value, new Date(i.setAt));
};

var Metadatum =
/** @class */
function () {
  function Metadatum(domain, key, value, setAt) {
    this.domain = domain;
    this.key = key;

    if (value != null) {
      this.value = value;
    } else {
      this.value = "";
    }

    if (setAt != null) {
      this.setAt = setAt;
    } else {
      this.setAt = new Date(0);
    }
  }

  Metadatum.prototype.get = function (uuid, credentials) {
    var _this = this;

    return metadata_1.get(credentials, uuid, this.domain, this.key).then(function (ret) {
      var id = exports.decodeMetadata(ret);

      if (id.value.length > 0) {
        _this.value = id.value;
      }

      if (id.setAt.getTime() > 0) {
        _this.setAt = id.setAt;
      }

      return id;
    });
  };

  return Metadatum;
}();

exports.Metadatum = Metadatum;

exports.getAllMetadata = function (uuid, credentials, domain) {
  var dom = domain;

  if (dom == null) {
    dom = "";
  }

  return metadata_1.get(credentials, uuid, dom).then(function (ret) {
    var e_1, _a;

    var md = [];

    try {
      for (var ret_1 = __values(ret), ret_1_1 = ret_1.next(); !ret_1_1.done; ret_1_1 = ret_1.next()) {
        var r = ret_1_1.value;
        md.push(exports.decodeMetadata(r));
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (ret_1_1 && !ret_1_1.done && (_a = ret_1.return)) _a.call(ret_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    return md;
  });
};